import React from "react";
import { Button } from "@ts-digital/vrc";
import "./style.css";
import { FormattedMessage } from "react-intl";

const UserSettingsButtons = ({
  changeInSettings,
  resetUserPermissions,
  saveUserPermissions
}) => {

  return (
    <div className="userButtonsContent">
      <Button
        id="buttonCancelSettings"
        className="userButtonReset"
        type="submit"
        onClick={resetUserPermissions}
        disabled={!changeInSettings}
      >
        <FormattedMessage id="generic.cancel" />
      </Button>
      <Button
        id="buttonApplySettings"
        className="userButtonApply"
        type="submit"
        onClick={saveUserPermissions}
        disabled={!changeInSettings}
      >
        <FormattedMessage id="settings.applyPermissions" />
      </Button>
    </div>
  );
};

export default UserSettingsButtons;